import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Calendar } from "primereact/calendar";
import { MultiSelect } from "primereact/multiselect";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const apiUrl = process.env.REACT_APP_API_URL;

export const ModifierLocation = ({
  setModifierLocation,
  idSelected,
  setFiltre,
  onClose,
}) => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("info");

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [idLocation, setIdLocation] = useState("");
  const [idClient, setIdClient] = useState("");
  const [idStockage, setIdStockage] = useState("");
  const [nomCompl, setNomCompl] = useState("");
  const [num, setNum] = useState("");
  const [mail, setMail] = useState("");
  const [adresse, setAdresse] = useState("");
  const [dateReservation, setDateReservation] = useState(null);
  const [dateEntree, setDateEntree] = useState(null);
  const [dateSortie, setDateSortie] = useState(null);
  const [loyer, setLoyer] = useState("");
  const [totVolume, setTotVolume] = useState("");
  const [noteLoc, setNoteLoc] = useState("");
  const [selectedValue, setSelectedValue] = useState([]);
  const [stockageOptions, setStockageOptions] = useState([]);
  const [prixM3, setPrixM3] = useState(12);
  const [sumVol, setSumVol] = useState(0);
  const [stockageVolumes, setStockageVolumes] = useState({});

  const showMessage = (sev, detail) => {
    setSeverity(sev);
    setMessage(detail);
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenSnackbar(false);
  };



  //  Récupérer le volume d'un stockage spécifique
  const getVolumeStockage = async (id) => {
  try {
    const response = await axios.get(`${apiUrl}IHM/api/stockage.php?idStockage=${id}`);
    let data = response.data;
        if (Array.isArray(data) && data.length > 0) {
      if (Array.isArray(data[0])) {
        data = data[0];
      }
      if (data && typeof data === 'object' && data.vol !== undefined) {
        return parseFloat(data.vol) || 0;
      }
      if (Array.isArray(data) && data.length > 0 && data[0].vol !== undefined) {
        return parseFloat(data[0].vol) || 0;
      }
    }
    return 0;
  } catch (error) {
    console.error(`Erreur récupération volume pour ${id}:`, error);
    return 0;
  }
};

  //  Récupérer les données de la location
  useEffect(() => {
    if (idSelected) {
      setLoading(true);
      axios
        .get(`${apiUrl}IHM/api/location.php?id=${idSelected}`)
        .then(async (response) => {
          const data = response.data[0];
          if (data) {
            setIdLocation(data.idLocation);
            setIdClient(data.idClient);
            setIdStockage(data.idStockage);
            setNomCompl(data.nom);
            setNum(`${data.num1} - ${data.num2}`);
            setMail(data.mail);
            setAdresse(`${data.ville} - ${data.codePostal} - ${data.adresse}`);
            setDateReservation(data.dateReservation ? new Date(data.dateReservation) : null);
            setDateEntree(data.dateEntree ? new Date(data.dateEntree) : null);
            setDateSortie(data.dateSortie ? new Date(data.dateSortie) : null);
            setLoyer(data.loyer || "");
            setTotVolume(data.totVolume || "");
            setNoteLoc(data.noteLocation || "");
            
            //  Récupérer les stockages avec leurs volumes
            const stockageIds = data.idStockage ? data.idStockage.split('||').map(s => s.trim()) : [];
            setSelectedValue(stockageIds);
            
            //  Récupérer le volume pour chaque stockage
            const volumes = {};
            let totalVol = 0;
            for (const id of stockageIds) {
              const vol = await getVolumeStockage(id);
              volumes[id] = vol;
              totalVol += vol;
            }
            setStockageVolumes(volumes);
            setSumVol(totalVol);
            
            //  Récupérer tous les stockages disponibles
            await recStockage(volumes);
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error("Erreur:", error);
          setLoading(false);
        });
    }
  }, [idSelected]);

  //  Récupérer les stockages disponibles
  const recStockage = async (existingVolumes = {}) => {
    try {
      const response = await axios.get(`${apiUrl}IHM/api/stockage.php`);
      const data = response.data;
      if (Array.isArray(data)) {
        const options = data.map((item) => ({
          label: `${item.idStockage} - ${item.vol} m³`,
          value: item.idStockage,
          vol: parseFloat(item.vol) || 0,
        }));
        
        //  Fusionner avec les volumes existants
        const allOptions = [...options];
        
        // Ajouter les stockages existants qui ne sont pas dans la liste
        Object.keys(existingVolumes).forEach(id => {
          if (!allOptions.find(opt => opt.value === id)) {
            allOptions.push({
              label: `${id} - ${existingVolumes[id]} m³`,
              value: id,
              vol: existingVolumes[id]
            });
          }
        });
        
        setStockageOptions(allOptions);
      }
    } catch (error) {
      console.error("Erreur lors de la requête : ", error);
    }
  };

  //  Gestion de la sélection des stockages
  const handleSelectionChange = async (e) => {
    const newSelected = e.value || [];
    setSelectedValue(newSelected);
    
    //  Recalculer le volume total
    let totalVol = 0;
    const volumes = { ...stockageVolumes };
    
    for (const id of newSelected) {
      // Si on n'a pas déjà le volume, le récupérer
      if (!volumes[id]) {
        const vol = await getVolumeStockage(id);
        volumes[id] = vol;
      }
      totalVol += volumes[id];
    }
    
    setStockageVolumes(volumes);
    setSumVol(totalVol);
  };

  //  Supprimer un stockage des chips
  const removeStockage = (idToRemove) => {
    const newSelected = selectedValue.filter(id => id !== idToRemove);
    setSelectedValue(newSelected);
    
    // Recalculer le volume total
    const totalVol = newSelected.reduce((acc, id) => acc + (stockageVolumes[id] || 0), 0);
    setSumVol(totalVol);
  };

  //  Formater la date
  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  };

  //  Soumettre la modification
 const faireModification = async (e) => {
    e.preventDefault();

    if (!idClient) {
        showMessage("warn", "Veuillez vérifier les informations");
        return;
    }

    if (selectedValue.length === 0) {
        showMessage("warn", "Veuillez sélectionner au moins un stockage");
        return;
    }

    setIsSubmitting(true);

    let entreeFormate = dateEntree ? formatDate(dateEntree) : null;
    let sortieFormate = dateSortie ? formatDate(dateSortie) : null;
    let resFormate = dateReservation ? formatDate(dateReservation) : null;

    const nouveauxStockages = selectedValue.join(' || ');
    const anciensStockages = idStockage; 

    const data = {
        idLocation: idLocation,
        idClient: idClient,
        dateReservation: resFormate,
        dateEntree: entreeFormate,
        dateSortie: sortieFormate,
        totVolume: sumVol,
        loyer: loyer,
        noteLoc: noteLoc,
        idStockage: nouveauxStockages,
    };

    try {
        const stockageChange = anciensStockages && anciensStockages !== nouveauxStockages;
        
        if (sortieFormate) {
            await axios.post(`${apiUrl}IHM/api/location.php`, data);
        } 
        else if (stockageChange) {
            await axios.post(`${apiUrl}IHM/api/stockage.php?idSliberer=${anciensStockages}`);
            
            await axios.post(`${apiUrl}IHM/api/location.php`, data);
        } 
        else {
            await axios.post(`${apiUrl}IHM/api/location.php`, data);
        }

        showMessage("success", "Location modifiée avec succès");
        setTimeout(() => {
            setModifierLocation(false);
            setFiltre(sortieFormate ? "terminee" : "enCours");
            if (typeof onClose === "function") onClose();
            window.location.reload();
        }, 1500);
    } catch (error) {
        console.error("Erreur:", error);
        showMessage("error", "Erreur lors de la modification");
    } finally {
        setIsSubmitting(false);
    }
};

  const header = (
    <div className="flex justify-content-between align-items-center w-full">
      <span className="font-semibold text-lg">Modifier la location</span>
    </div>
  );

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        message={message}
        action={
          <IconButton size="small" color="inherit" onClick={handleCloseSnackbar}>
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      />

      <Dialog
        blockScroll
        visible={true}
        header={header}
        className="custom-dialog"
        style={{ width: "60vw", maxWidth: "800px" }}
        modal
        onHide={() => {
          setModifierLocation(false);
          if (typeof onClose === "function") onClose();
        }}
        breakpoints={{ "960px": "90vw", "640px": "95vw" }}
      >
        {loading ? (
          <div className="flex justify-content-center p-5">
            <i className="pi pi-spin pi-spinner" style={{ fontSize: "2rem", color: "#2563eb" }}></i>
          </div>
        ) : (
          <div className="p-3">
            {/* Section 1 - Informations client */}
            <div className="grid">
              <div className="col-12">
                <div
                  style={{
                    background: "#f3f4f6",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    marginBottom: "10px",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  <span
                    style={{
                      background: "#374151",
                      color: "white",
                      borderRadius: "50%",
                      width: "18px",
                      height: "18px",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "11px",
                      fontWeight: 700,
                    }}
                  >
                    1
                  </span>
                  <span
                    style={{
                      fontSize: "11px",
                      fontWeight: 600,
                      color: "#374151",
                      letterSpacing: "0.05em",
                    }}
                  >
                    INFORMATIONS CLIENT
                  </span>
                </div>
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-6">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  ID Location
                </label>
                <InputText value={idLocation} disabled className="w-full" style={{ height: "36px", background: "#f9fafb" }} />
              </div>
              <div className="col-12 md:col-6">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Client
                </label>
                <InputText value={`${idClient} - ${nomCompl}`} disabled className="w-full" style={{ height: "36px", background: "#f9fafb" }} />
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-6">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Email
                </label>
                <InputText value={mail} disabled className="w-full" style={{ height: "36px", background: "#f9fafb" }} />
              </div>
              <div className="col-12 md:col-6">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Téléphone
                </label>
                <InputText value={num} disabled className="w-full" style={{ height: "36px", background: "#f9fafb" }} />
              </div>
            </div>

            <div className="grid">
              <div className="col-12">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Adresse
                </label>
                <InputText value={adresse} disabled className="w-full" style={{ height: "36px", background: "#f9fafb" }} />
              </div>
            </div>

            {/* Section 2 - Informations location */}
            <div className="grid mt-2">
              <div className="col-12">
                <div
                  style={{
                    background: "#f3f4f6",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    marginBottom: "10px",
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                  }}
                >
                  <span
                    style={{
                      background: "#374151",
                      color: "white",
                      borderRadius: "50%",
                      width: "18px",
                      height: "18px",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "11px",
                      fontWeight: 700,
                    }}
                  >
                    2
                  </span>
                  <span
                    style={{
                      fontSize: "11px",
                      fontWeight: 600,
                      color: "#374151",
                      letterSpacing: "0.05em",
                    }}
                  >
                    STOCKAGES
                  </span>
                </div>
              </div>
            </div>

            {/* Sélection des stockages avec MultiSelect */}
            <div className="grid">
              <div className="col-12">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Sélectionner les stockages
                </label>
                <MultiSelect
                  value={selectedValue}
                  options={stockageOptions}
                  onChange={handleSelectionChange}
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Choisir les stockages..."
                  className="w-full"
                  filter={false}
                  style={{ height: "36px" }}
                />
              </div>
            </div>

            {/* AFFICHAGE DES CHIPS AVEC LES VOLUMES */}
            <div className="grid">
              <div className="col-12">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "6px" }}>
                  Stockages sélectionnés ({selectedValue.length})
                </label>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "6px",
                    padding: "8px",
                    border: "1px solid #e5e7eb",
                    borderRadius: "6px",
                    minHeight: "40px",
                    background: "#fafafa",
                  }}
                >
                  {selectedValue.length > 0 ? (
                    selectedValue.map((id) => {
                      const vol = stockageVolumes[id] || 0;
                      return (
                        <div
                          key={id}
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            background: "#dbeafe",
                            color: "#1d4ed8",
                            fontWeight: 500,
                            fontSize: "13px",
                            padding: "4px 12px",
                            borderRadius: "16px",
                            border: "1px solid #bfdbfe",
                          }}
                        >
                          <span>{id} - {vol} m³</span>
                          <button
                            type="button"
                            onClick={() => removeStockage(id)}
                            style={{
                              border: "none",
                              background: "transparent",
                              cursor: "pointer",
                              padding: 0,
                              margin: 0,
                              fontSize: "14px",
                              color: "#1d4ed8",
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                              lineHeight: 1,
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.color = "#dc2626"}
                            onMouseLeave={(e) => e.currentTarget.style.color = "#1d4ed8"}
                          >
                            ✕
                          </button>
                        </div>
                      );
                    })
                  ) : (
                    <span style={{ color: "#9ca3af", fontSize: "13px", padding: "4px 8px" }}>
                      Aucun stockage sélectionné
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="grid mt-2">
              <div className="col-12 md:col-6">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Date de réservation
                </label>
                <Calendar
                  value={dateReservation}
                  onChange={(e) => setDateReservation(e.value)}
                  dateFormat="dd/mm/yy"
                  className="w-full"
                  showIcon={false}
                  disabled
                  style={{ height: "36px" }}
                />
              </div>
              <div className="col-12 md:col-6">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Date d'entrée
                </label>
                <Calendar
                  value={dateEntree}
                  onChange={(e) => setDateEntree(e.value)}
                  dateFormat="dd/mm/yy"
                  className="w-full"
                  showIcon={false}
                  style={{ height: "36px" }}
                />
              </div>
            </div>

            <div className="grid">
              <div className="col-12 md:col-6">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Date de sortie
                </label>
                <Calendar
                  value={dateSortie}
                  onChange={(e) => setDateSortie(e.value)}
                  dateFormat="dd/mm/yy"
                  className="w-full"
                  showIcon={false}
                  style={{ height: "36px" }}
                />
              </div>
              <div className="col-12 md:col-6">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Loyer mensuel (€)
                </label>
                <InputText
                  value={loyer}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (/^[+]?\d*\.?\d*$/.test(val) || val === "") {
                      setLoyer(val);
                    }
                  }}
                  className="w-full"
                  style={{ height: "36px" }}
                />
              </div>
            </div>

            <div className="grid">
              <div className="col-12">
                <label style={{ fontSize: "12px", color: "#374151", display: "block", marginBottom: "2px" }}>
                  Note
                </label>
                <InputTextarea
                  value={noteLoc}
                  onChange={(e) => setNoteLoc(e.target.value)}
                  rows={3}
                  className="w-full"
                  style={{ resize: "vertical" }}
                />
              </div>
            </div>

            {/* Récapitulatif avec calcul en bas */}
            <div className="grid mt-2">
              <div className="col-12">
                <div
                  style={{
                    background: "#f5f3eb",
                    borderRadius: "5px",
                    padding: "8px 12px",
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", fontSize: "14px", fontWeight: 600 }}>
                    <span>Récapitulatif</span>
                    <span>{selectedValue.length} box sélectionné(s)</span>
                  </div>
                  {selectedValue.map((id) => {
                    const vol = stockageVolumes[id] || 0;
                    return (
                      <div key={id} style={{ display: "flex", justifyContent: "space-between", padding: "4px 0", fontSize: "13px", color: "#6b7280" }}>
                        <span>{id}</span>
                        <span>{vol.toFixed(2)} m³</span>
                      </div>
                    );
                  })}
                  <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", borderTop: "1px solid #d1d5db", marginTop: "4px", fontWeight: 600 }}>
                    <span>Volume total</span>
                    <span>{sumVol.toFixed(2)} m³</span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", padding: "6px 0", fontWeight: 700, fontSize: "15px", color: "#1d4ed8" }}>
                    <span>Loyer estimé</span>
                    <span>{(sumVol * 13).toFixed(2)} €</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Bouton modifier */}
            <div className="grid mt-3">
              <div className="col-12">
                <Button
                  label="Modifier la location"
                  icon="pi pi-check"
                  className="w-full"
                  onClick={faireModification}
                  disabled={isSubmitting}
                  style={{
                    background: "#0971b7",
                    border: "none",
                    padding: "0.75rem",
                    borderRadius: "6px",
                    fontSize: "14px",
                    fontWeight: 500,
                    justifyContent: "center",
                    gap: "8px",
                    color: "white",
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </Dialog>
    </>
  );
};